<template>
<div>
  
<button  v-if="type=='A'" @click="type=''"  type="button" class="btn btn-outline-info" >
 <i style="color:brown" class="fas fa-paint-brush mr-2" aria-hidden="true"></i>
  CREA UN NUOVO COLORE
</button>



<div v-else class="card border shadow-lg bg-white rounded border-info card-bold-border">
    <div class="card-header bg-info border-success text-white">CREA UN NUOVO COLORE</div>
    
    <div class="card-body">    
    <form class="form-inline" v-on:submit.prevent="submit()">
      <label class="sr-only" for="inlineFormInput">NUOVO COLORE</label>
      <div class="input-group mr-sm-2" style="width: 400px;">   
          <input v-focus required type="text" v-model="color" class="form-control mb-2 mr-2 w-100" id="inputColor" placeholder="Inserisci un nuovo colore"></input>
      </div>

      
  <button type="submit" class="btn btn-primary mb-2">CREA COLORE
      <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
  </button>
  <button @click="setForm()" type="button" class="btn btn-outline-secondary  mb-2 ml-2">ANNULLA</button>


</form>  

  </div>

  <div class="card-footer bg-transparent border-success">
    <div v-if="msg"
              class="alert "
              :class="alertClass"
              role="alert"
              >
              {{ msg }}
        </div>

  </div>
</div>
  
</div>
</template>

<script>


import { mapGetters } from 'vuex';

import api from '@/api'
  export default {
  props : ['colors'],

  components: {},
    data () {
      return {
        
        type         : 'A',
        color        : '',
        msg          : '',        
        spinner      : false,
        alertClass   : 'alert-warning' // default
        
                             
      }
    },

   
     directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },

    computed: {
    ...mapGetters(['company']),
           
    },
    mounted()
    { 
      
     
         
    },
    created () 
      {       
          this.msg = ''
          this.color = ''
      },
    methods: 
    {
     
      
      setForm()
      {
        this.color = ''
        this.msg   = ''
        this.type  = 'A'
      },
      async submit()
      {

      this.msg     = ''  
      this.spinner = true
      const sp   = {'sp'    : 'spCreateNewColor'}      
      const data = {'color' : this.color,'companyId' : this.company.Id}
      const json = Object.assign(data, sp)
   
      await api.post(json).then(res => {
          
          if(res.status==200)
            {
            
                
                this.msg = 'COLORE CREATO.'
                this.alertClass = 'alert-success';
            
            
                         
            }
           else if(res.status==500)
           {
                console.log(res.data)
                this.msg = res.data
                this.alertClass = 'alert-danger';
                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
              this.spinner = false
        });



      }
      }
      
      

    
  }
</script>
<style scoped>


.card-bold-border {
    border-width: 3px !important;
}

</style>
